import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import trimText from 'lib/trimText';
import Breakpoints from 'lib/Breakpoints';
import styles from './WaffleTextSummaryStyles.scss';

const block = 'waffle__summary-text';

// can either take two text inputs or it can split one based on character lengths
// can either build text with HTML input or pure string

const textType = {
  MORE_INFO: 'more-info',
  DEK: 'dek',
};

class WaffleTextSummary extends React.Component {
  static propTypes = {
    dekText: PropTypes.string,
    moreInfoText: PropTypes.string,
    showDek: PropTypes.bool,
    showMoreInfo: PropTypes.bool,
    trimDekText: PropTypes.bool,
    allowHTMLText: PropTypes.bool,
    textClasses: PropTypes.string,
    mobileExpand: PropTypes.bool,
    moreInfoClasses: PropTypes.string,
  };

  static defaultProps = {
    dekText: '',
    moreInfoText: '',
    showMoreInfo: false,
    showDek: false,
    trimDekText: false,
    allowHTMLText: false,
    textClasses: '',
    mobileExpand: false,
    moreInfoClasses: '',
  };

  componentDidMount() {
    this.contentHeight = this.moreInfoElem && this.moreInfoElem.scrollHeight;
  }

  addBreaksToText = (text, type) => {
    if (type === textType.DEK) return text;

    const { allowHTMLText } = this.props;
    if (allowHTMLText) {
      return text.split('\n').map((paragraph) => (
        `<p>${paragraph}</p>`)).join('');
    }

    return text.split('\n').map((paragraph) => (
      <p>
        {paragraph}
      </p>
    ));
  }

  render() {
    let { dekText } = this.props;
    const {
      moreInfoText,
      showMoreInfo,
      showDek,
      trimDekText,
      textClasses,
      allowHTMLText,
      mobileExpand,
      moreInfoClasses,
    } = this.props;

    const textClassnames = `${styles.summaryText} ${textClasses} lh-copy gray-80 f3 publico-txt mv0 pt3`;

    if (!showDek && !showMoreInfo) {
      return null;
    }

    // Trim dek if required
    if (showDek && dekText && trimDekText) {
      dekText = trimText(dekText, 60);
    }

    const buildPTag = (text, type) => {
      const pTagAttributes = {
        'data-test': `text-summary--${type}`,
        className: textClassnames,
      };
      if (type === textType.MORE_INFO) {
        pTagAttributes.ref = (element) => { this.moreInfoElem = element; };
        pTagAttributes.className += ` ${moreInfoClasses}`;
      }

      const textWithBreaks = this.addBreaksToText(text, type);

      if (allowHTMLText) {
        pTagAttributes.dangerouslySetInnerHTML = { __html: textWithBreaks };
      } else {
        pTagAttributes.children = textWithBreaks;
      }

      return (
        <div {...pTagAttributes} />
      );
    };

    const dekTextParagraph = showDek && dekText !== ''
      ? buildPTag(dekText, textType.DEK) : null;
    const showMoreTextParagraph = showMoreInfo && moreInfoText !== ''
      ? buildPTag(moreInfoText, textType.MORE_INFO) : null;

    return (
      <div className={block}>
        { dekTextParagraph }
        { showMoreTextParagraph }
        { mobileExpand && showMoreInfo && moreInfoText !== '' && Breakpoints.isS()
          && (
          <div
            data-test="text-summary--more-info--mobile"
            className={classNames(
              'overflow-hidden dn-m',
              styles.moreInfoWrapper,
              { 'o-0': !showMoreInfo, 'o-100': showMoreInfo },
            )}
            style={{ height: (showMoreInfo && this.contentHeight) || 0 }}
          >
            { showMoreTextParagraph }
          </div>
          )}
      </div>
    );
  }
}

export default WaffleTextSummary;
